
import { Component, Prop, Vue } from "vue-property-decorator";
import UdcBannerGeneric from "@/components/UdcBannerGeneric.vue";

@Component({
  name: "celebrus-hb-rop",
  components: {
    UdcBannerGeneric
  }
})
export default class CelebrusHbRop extends Vue {
  @Prop() private banner!: any;
  @Prop() private methods!: any;

  private getProvenanceName() {
    if (this.banner.message_id) {
      return this.banner.message_id.match(/BAN_SECOURS/)
        ? "emergencyBanner"
        : "rtim";
    } else {
      return "rtim";
    }
  }
}
